import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './app.state';
import { MainService } from './_services/main.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, NavigationStart, NavigationError, NavigationEnd, Event } from '@angular/router'; 
import { ResizedEvent } from 'angular-resize-event';
import { MobileScreenData } from './store/actions/appActions';
import { ChatAdapterHistory } from './_services/chat-adapter';
import { ResultboardService } from './resultboard/resultboard.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material';
import { OneSignalService } from './_services/onesignal.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Draft';
  alldata: string;
  myTeamData: any;
  shows: any;
  errors: string;
  currentUser: any;
  user_id: number;
  teamCursor: 1;
  isMobile:any;
  width: number;
  height: number;
  loginUserID: number;
  assetsUrl: String = `${environment.assetURL}`;
  isAppView = true;
  sub_isMobileScreen: Subscription;
  pageName: any;
  deviceType = '';
  curshowSmartBanner = false;
  constructor(private _appService: MainService, private store: Store<AppState>,
    private deviceService: DeviceDetectorService,private router: Router,
    private spinner: NgxSpinnerService, public _resultBoardService:ResultboardService, 
    public dialog: MatDialog,private oneSignalService: OneSignalService) { 
    this.isMobile = this.deviceService.isMobile();
    this.pageName = this.router.url.split('/');
    this.isMobile = this.deviceService.isMobile();
    if(this.sub_isMobileScreen) { this.sub_isMobileScreen.unsubscribe(); }
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
    router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {
        // Show loading indicator 
        this.spinner.show();
        this.dialog.closeAll();
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator 
        this.spinner.hide();
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser !== null) {
          this.loginUserID = this.currentUser.id;
        }
        this.isAppView = (this.router.url.split('/')[1] == 'player')?true:false;
        this.pageName = this.router.url.split('/');
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
        this.spinner.hide();
      }
    });
    this.checkSmartBanner();
  }
  
  getSetting() {
    this._appService.getSetting()
      .subscribe(shows => {
        if(shows && shows.entities)
        this.alldata = shows.entities;
      }, err => { 
        this.errors = <any>err;
      });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser !== null) {
      this.loginUserID = this.currentUser.id;
    } 
    this.store.select('user').subscribe(state => {
      if(state[0]){
        this.loginUserID = state[0]['user_id'];
        //this.chatservice.onConnectUser();
      } 
    });
  }  
  
  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;
    if(this.width < 1000){
      this.isMobile = true;
      this.store.dispatch(new MobileScreenData(
        this.isMobile
      )); 
    }else{
      this.isMobile = false;
      this.store.dispatch(new MobileScreenData(
        this.isMobile
      )); 
    }
  }

  
  public messageSeen(event: any)
  {
    if(event && event[0]){
      const data = {'friend_id':event[0].fromId, 'user_id': event[0].toId};
      this._resultBoardService.readMsgCount(data);
    }
  }

  // event is different from ng-chat.js
  public onParticipantClicked(event: any)
  {
    this.loadScript('assets/js/jquery_basic.js');
    this.loadScript('assets/js/config.js');
    this.loadScript('assets/js/util.js');
    this.loadScript('assets/js/jquery.emojiarea.js');
    this.loadScript('assets/js/emoji-picker.js');
    this.loadScript('assets/js/emo_sel.js');
  }
  
  
  loadScript(url) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  ngAfterViewInit(): void {

  }
  checkSmartBanner(){
    this.deviceType = this.deviceService.os;
    if(this.deviceType=='iOS' || this.deviceType=='Android')
    this.curshowSmartBanner = true;
  }
  updateShowBannerChange($event) {
    this.curshowSmartBanner = $event;
  }

}